<template>
    <div id="page">
        <div class="page-content">
            <div class="page-title page-title-small">
                <h2>
                    <button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>
                    ثبت پست سازمانی
                    <button data-menu="HelpMenu" class="position-static mr-1"><i class="fa fa-question-circle helpIco"></i></button>
                </h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="150">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
                <div class="card-bg bg-20"></div>
            </div>
            <div class="card card-style">
                <div class="content mb-0">

                    <div class="input-style input-style-2 has-icon input-required">
                        <i class="input-icon fa fa-check color-magenta2-light"></i>
                        <span class="color-highlight" :class="{'input-style-1-active' : orgJobModel.title!==null}">عنوان</span>
                        <input class="form-control" type="text" v-model="orgJobModel.title" @input="v$.orgJobModel.title.$touch()" :class="{invalid:v$.orgJobModel.title.$error}">
                        <p class="text-danger" v-if="v$.orgJobModel.title.required.$invalid && v$.orgJobModel.title.$dirty">لطفا عنوان را وارد کنید.</p>
                    </div>


                    <button :disabled="Loading" class="btn btn-xxs mt-2 mb-4 btn-full bg-green1-dark rounded-sm font-900 w-100" @click.prevent="CreateOrgJob">
                        <i class="fa fa-check font-10 ml-2"></i>
                        ثبت
                    </button>
                </div>
            </div>
        </div>
        <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
            <div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
                <div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>درحال ارسال اطلاعات ...</div>
            </div>
        </transition>
    </div>

    <Help-Menu title="معرفی موبایل اپلیکیشن تسکینو" keyEn="TaskList"></Help-Menu>
    <!--<div id="orgJobHelp" class="menu menu-box-right bg-gray" data-menu-width="100%" data-menu-effect="menu-over">
        <div class="position-relative">
            <button @click="pauseAllVid()" class="close-menu"><i class="fa fa-times text-white font-26"></i></button>
            <div class="card" data-card-height="90">
                <div class="card-top">
                    <div class="page-title page-title-small">
                        <h2 class="text-center">معرفی موبایل اپلیکیشن تسکینو</h2>
                    </div>
                </div>
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>

                <div class="card-bg bg-20"></div>
            </div>
            <div class="card card-style">
                <div class="content mt-0 pb-2">
                    <div class="list-group list-custom-small list-icon-0 mt-3 border-b">
                        <div data-toggle="collapse" href="#collapse-0" class="collapsed list-group-div" aria-expanded="false">
                            <i class="fa font-14 fa-info-circle color-magenta1-light"></i>
                            <span class="font-14">معرفی موبایل اپلیکیشن تسکینو <span class="badge bg-red2-light mt-0 px-2 py-2 mr-2 position-static">مهم</span></span>
                            <i class="fa fa-angle-down line-height-xl"></i>
                        </div>
                    </div>
                    <div class="collapse border-b pb-3" id="collapse-0" style="">
                        <div class="d-flex justify-content-center">
                            <video class="responsive-video" controls id="video0" preload="none" poster="/assets/images/taskAppHelpVideoPoster.jpg">
                                <source src="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro-OrgJob.mp4" type="video/mp4">
                            </video>
                        </div>
                        <a href="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro-OrgJob.mp4" download target="_blank" class="btn btn-m btn-full bg-highlight rounded-m font-900 mt-3 mx-3">دانلود</a>
                    </div>
                </div>
            </div>
        </div>
    </div>-->
</template>
<script>
import useVuelidate from '@vuelidate/core'
    import {
        required
    } from "@vuelidate/validators";
    import 'vue-select/dist/vue-select.css';
    import HelpMenu from '../Components/HelpMenu.vue';
    export default {
        components: {
            "Help-Menu": HelpMenu
        },
        setup: () => ({ v$: useVuelidate() }),
        data() {
            return {
                orgJobModel: {
                    code: "",
                    title: null,
                    orgJobId: 0,
                    userId: 0,
                    parentId: this.$route.params.parentId,
                    levelId: 0,
                    orgUnitId:0
                },

            };
        },
        computed: {
            Loading() {
                return this.$store.getters.GetLoading;
            },
          
        },
        methods: {
            
            CreateOrgJob() {
                this.v$.$touch(); //it will validate all fields
                if (!this.v$.$invalid) { //invalid, becomes true when a validations return false
                    this.$store.dispatch("CreateOrgJob", this.orgJobModel);
                }
               
            },
			pauseAllVid() {
				document.querySelectorAll('video').forEach(vid => vid.pause());
			},
           
        },

        validations: {
            orgJobModel: {
                title: {
                    required
                },
            }


        },
		mounted() {
			document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");
		},
    };
</script>
